import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=9e4a6cfa&scpoed=true&lang=css"

const __exports__ = script;

export default __exports__